import { createStore, applyMiddleware, AnyAction } from 'redux'
import createSagaMiddleware from 'redux-saga'
import thunk, { ThunkAction } from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'
import reducers from './reducers'
import { effects } from './effects'

export type RootState = ReturnType<typeof store.getState>
export type ThunkResult<Return> = ThunkAction<Return, RootState, undefined, AnyAction>

const effectMiddleware = createSagaMiddleware()

const store = createStore(
  reducers,
  composeWithDevTools(
    applyMiddleware(effectMiddleware),
    applyMiddleware(thunk)
  )
)

effectMiddleware.run(effects)

export default store
